import $ from 'jquery';
import TweenLite from 'TweenLite';
import Power2 from 'TweenLite';
import 'scrollToPlugin';

const selectors = {
	el: '.js-scroll-to-top'
};

const $el = $(selectors.el);

const scrollToTop = () => {
	TweenLite.to(window, 0.6, {
		scrollTo: {y: 0},
		ease: Power2.easeInOut
	});
};

const handleClick = () => $el.on('click', scrollToTop);

const render = () => {
	if ($el.length) {
		handleClick();
	}
};

export default render;



/** WEBPACK FOOTER **
 ** ./app/blocks/scroll-to-top/index.js
 **/